import React from 'react';
import TaskConditionRow from '../TaskConditionRow';
import './styles.css';

/**
 * UnlockBlock - A single condition block with configurable inner AND/OR logic.
 * Blocks are separated by a clickable outer AND/OR toggle.
 */
const UnlockBlock = ({
  block,
  blockIndex,
  blockNumber,
  isFirst,
  outerOperator,
  allTasks,
  onUpdateTask,
  onUpdateBranch,
  onUpdateWait,
  onRemoveCondition,
  onAddCondition,
  onRemoveBlock,
  onToggleOuterOperator,
  onToggleInnerOperator,
}) => {
  const conditions = block.conditions || [];
  const innerOp = block.innerOperator || 'AND';

  const hasValidTasks = conditions.some(t => {
    const taskId = typeof t === 'string' ? t : t?.taskId;
    return !!taskId;
  });

  const showInnerToggle = conditions.length > 1;

  return (
    <div className="conditions-modal__option">
      {/* Outer operator toggle between blocks */}
      {!isFirst && (
        <div className="conditions-modal__or-divider">
          <button
            className={`conditions-modal__operator-toggle conditions-modal__operator-toggle--${(outerOperator || 'AND').toLowerCase()}`}
            onClick={() => onToggleOuterOperator(blockIndex)}
            type="button"
            title={`Click to switch to ${outerOperator === 'AND' ? 'OR' : 'AND'}`}
          >
            {outerOperator || 'AND'}
          </button>
        </div>
      )}

      {/* Block box */}
      <div className="conditions-modal__option-box">
        {/* Block header */}
        <div className="conditions-modal__option-header">
          <div className="conditions-modal__option-title-group">
            <span className="conditions-modal__option-title">
              Block {blockNumber}
            </span>
            {showInnerToggle ? (
              <span className="conditions-modal__option-description">
                Conditions linked by:{' '}
                <button
                  className={`conditions-modal__inner-toggle conditions-modal__inner-toggle--${innerOp.toLowerCase()}`}
                  onClick={() => onToggleInnerOperator(blockIndex)}
                  type="button"
                  title={`Click to switch to ${innerOp === 'AND' ? 'OR' : 'AND'}`}
                >
                  {innerOp}
                </button>
              </span>
            ) : (
              <span className="conditions-modal__option-description">
                Required condition:
              </span>
            )}
          </div>
          <button
            className="conditions-modal__option-remove"
            onClick={() => onRemoveBlock(blockIndex)}
            type="button"
            title="Remove this block"
          >
            ×
          </button>
        </div>

        {/* Conditions list with inner operator labels */}
        <div className="conditions-modal__option-tasks">
          {conditions.map((taskEntry, condIndex) => (
            <React.Fragment key={condIndex}>
              {condIndex > 0 && (
                <div className="conditions-modal__inner-operator-label">
                  <span className={`conditions-modal__inner-op-text conditions-modal__inner-op-text--${innerOp.toLowerCase()}`}>
                    {innerOp}
                  </span>
                </div>
              )}
              <TaskConditionRow
                taskEntry={taskEntry}
                taskIndex={condIndex}
                optionIndex={blockIndex}
                allTasks={allTasks}
                canRemove={conditions.length > 1}
                onUpdateTask={onUpdateTask}
                onUpdateBranch={onUpdateBranch}
                onUpdateWait={onUpdateWait}
                onRemoveTask={onRemoveCondition}
              />
            </React.Fragment>
          ))}
        </div>

        {/* Add another condition */}
        {hasValidTasks && (
          <button
            className="conditions-modal__add-task"
            onClick={() => onAddCondition(blockIndex)}
            type="button"
          >
            + Add another condition
          </button>
        )}
      </div>
    </div>
  );
};

export default UnlockBlock;
